class SignaturePanels {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/signature-panels`;
    this.apiClient = apiClient;

  }

  async setupSignaturePanel(data) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getPopulatedSignaturePanelById(panelId) {

    const path = `${this.basePath}/:panelId`;

    return this.apiClient.get(path, { panelId }, {});

  }

  async addSignees(panelId, data) {

    const path = `${this.basePath}/:panelId/signees`;

    return this.apiClient.post(path, { panelId }, {}, data);

  }

  async deleteSignee(panelId, signeeId) {

    const path = `${this.basePath}/:panelId/signees/:signeeId`;

    return this.apiClient.delete(path, { panelId, signeeId }, {});

  }

  async deleteSignaturePanel(panelId) {

    const path = `${this.basePath}/:panelId`;

    return this.apiClient.delete(path, { panelId }, {});

  }

}

export default SignaturePanels;